import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass({ 'gfu-balloon__content-link': !$options.onlyIcon, 'gfu-balloon__content-link--disabled': !$options.onlyIcon && !$props.enabled }),
    href: $props.href,
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClick && $options.onClick(...args)))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass([
            'gfu-btn--toggler',
            $options.onlyIcon ? `gfu-btn gfu-btn--circle gfu-btn--${$props.type}` : 'gfu-balloon__content-icon',
            $props.buttonClass
        ])
    }, [
      ($props.icon)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.icon
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (!$options.onlyIcon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          "data-qa": `action-button:${$props.qa ?? $props.label}`
        }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}